module.exports = __webpack_public_path__ + "static/media/profile.06035c40.svg";